import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { Utils } from '@src/utils/util';
import { EnvironmentTypeComponent} from './environmentType'
import {HttpClientModule} from '@angular/common/http';
import { EnvironmentModule } from './environment/environment.module';

@NgModule({
    imports: [SharedModule, HttpClientModule,EnvironmentModule ],
    declarations: [EnvironmentTypeComponent],
    entryComponents: [EnvironmentTypeComponent],
    exports: [EnvironmentTypeComponent],
    providers: [ Utils]
})

export class EnvironmentTypeModule{}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/pipeline/environments-ang7/environmentType.module.ts